import {TOUCH} from 'three';
import type {OrbitControls} from 'three/addons/controls/OrbitControls.js';

export function enableRoomViewGestures(controls:OrbitControls){
 controls.enablePan=true;controls.enableZoom=true;controls.touches.TWO=TOUCH.DOLLY_PAN;
}

/** Locked viewing leaves the complete pointer stream available to OrbitControls. */
export function bindRoomEditHandlers(element:HTMLElement,isLocked:()=>boolean,handlers:Record<string,EventListener>){
 const listeners=Object.entries(handlers).map(([type,handler])=>{
  const listener:EventListener=event=>{if(!isLocked())handler(event)};
  element.addEventListener(type,listener,true);
  return {type,listener};
 });
 return()=>listeners.forEach(({type,listener})=>element.removeEventListener(type,listener,true));
}
